<template>
  <div class="FilterControls d-flex py-3">
    
    <FilterControl v-for="filter in filterInfo" :key="filter.id" :filter="filter" :last="lastActiveFilter" @remove="handleRemove" class="mb-5 mr-3" />

    <div class="FilterControls__disabled mb-5 mr-3" v-if="disabledFilters.length !== 0">
      <h3 class="ml-3 pl-3 mt-3">Eigenschap toevoegen</h3>

      <div class="p-3">
        <div class="d-flex mb-2" v-for="filter in disabledFilters" :key="filter.id" @click="handleEnable(filter)">
          <span>{{ filter.label }}</span>
          <SvgIcon icon="Plus-icon" class="ml-3" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import FilterControl from 'molecule/FilterControl'
import SvgIcon from 'atom/SvgIcon'

import { mapGetters } from 'vuex'

export default {
  name: 'FilterControls',
  components: { 
    FilterControl, SvgIcon
  },
  computed: {
    ...mapGetters('filters', [
      'getFilterInfo',
      'getActiveFilters',
    ]),
    filterInfo() {
      return Object.values(this.getFilterInfo({ mode: null }))
        // .filter(item => item.id !== 'bouwblok' && item.id !== 'bouwblok-auto' && item.id !== 'barcode')
        .filter(item => item.component && item.enabled)
        .map(item => {
          item.active = item.items.slice().filter(item => item.active)
          return item
        }) //.filter(item => item.active.length)
    },
    disabledFilters() {
      return Object.values(this.getFilterInfo({ mode: null }))
        // .filter(item => item.id !== 'bouwblok' && item.id !== 'bouwblok-auto' && item.id !== 'barcode')
        .filter(item => item.component && ! item.enabled)
    },
    lastActiveFilter() {
      return this.filterInfo.length === 1
    }
  },
  methods: {
    handleRemove(filter) {
      filter.enabled = false
    },
    handleEnable(filter) {
      filter.enabled = true
    }
  }
}
</script>

<style lang="scss">

.FilterControls {
  width: 100%;
  display: flex;
  flex-wrap: wrap;

  ul li {
    line-height: 1
  }

  .FilterControl {
    max-width: 244px;
    overflow-y: auto !important;

    ul {
      width: 230px;
      max-width: 230px;
    }

    &__back {
      display: none;
    }
  }
  &__disabled {
    max-width: 244px;
    overflow-y: auto !important;

    width: 100%;
    
    overflow-y: scroll;
    user-select: none;
    position: relative;

    h3 {
      font-size: 1.15em;
      font-weight: 700;
      margin-bottom: 20px;
      padding-left: 0.75rem;
      line-height: 1.5;
    }

    div {
      background: white;

      div {
        cursor: pointer;
        justify-content: space-between;

        &:hover {
          color: #599A50
        }
      }
    }
  }
}
</style>